/* Blazoer quick add-to-cart for product cards.
 * Uses Shopify Cart AJAX API and the theme's own cart drawer events
 * (same events the product form dispatches in theme.js). */
(function () {
  if (window.__bzQuickAdd) return;
  window.__bzQuickAdd = true;

  var live = document.createElement('div');
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('role', 'status');
  live.className = 'visually-hidden';
  live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);';
  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(live); });

  function announce(msg) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 50); }

  function addUrl() {
    var base = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    return base.replace(/\/$/, '') + '.js';
  }

  function strings(key, fallback) {
    return (window.theme && theme.strings && theme.strings[key]) || fallback;
  }

  function afterAdd(btn) {
    var body = document.body;
    try {
      if (window.Spruce && Spruce.store('drawer')) Spruce.store('drawer').cartOpener = btn;
    } catch (e) {}
    // Theme cart drawer listens for this: refreshes state, updates header count, opens drawer (show-on-add).
    body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
    // Same as theme.js: when cart method is "page" there is no drawer, so update the header count.
    if (!document.querySelector('[data-cart-drawer]') || (window.theme && theme.cartMethod === 'page')) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          body.dispatchEvent(new CustomEvent('baseline:modalcart:itemcountupdate', { detail: { count: state.item_count } }));
        })
        .catch(function () {});
    }
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-bz-quick-add]');
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;

    btn.setAttribute('aria-busy', 'true');
    btn.classList.remove('is-error', 'is-added');

    fetch(addUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        announce(strings('addedToCart', 'Toegevoegd aan winkelwagen'));
        afterAdd(btn);
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-error');
        var msg = (err && (err.description || err.message)) || strings('cartAddError', 'Er ging iets mis');
        announce(msg);
        if (window.console) console.warn('[Blazoer quick add]', msg);
        setTimeout(function () { btn.classList.remove('is-error'); }, 600);
      });
  }, true);
})();
